import cx from 'classnames'

import { Image } from '@/components/Image'
import { BodyM, HeadingL } from '@/components/Typography'

import { CONTAINER_BLACK_FRIDAY_PROPS } from '../constants'

import { FreeDocumentConsultingForms } from './FreeDocumentConsultingForms'
import { LinkIntegrityCheckForm } from './LinkIntegrityCheckForm'

import { MediaWithFormsContainer } from './styles'

type SectionPurpose = 'freeDocumentConsulting' | 'linkIntegrityCheck'

type ContentPosition = 'left' | 'right'

interface Props {
  title: string
  subtitle: string
  image?: {
    url: string
    alt: string
  }
  position: ContentPosition
  sectionPurpose: SectionPurpose
}

const FormsComponents = {
  freeDocumentConsulting: FreeDocumentConsultingForms,
  linkIntegrityCheck: LinkIntegrityCheckForm,
}

const MediaWithForms = ({ title, subtitle, image, position, sectionPurpose }: Props) => {
  const Forms = FormsComponents[sectionPurpose]

  return (
    <MediaWithFormsContainer
      {...CONTAINER_BLACK_FRIDAY_PROPS}
      contentClassName={cx('media-with-forms__content', {
        [`media-with-forms__content--${position}`]: position,
      })}
    >
      {!!image && (
        <div className="media-with-forms__image">
          <Image source={image.url} alt={image.alt || ''} width={400} height={344} />
        </div>
      )}

      {!!title && (
        <HeadingL light="solid" tag="h2" className="media-with-forms__title">
          {title}
        </HeadingL>
      )}

      {!!subtitle && (
        <BodyM light="solid" className="media-with-forms__subtitle">
          {subtitle}
        </BodyM>
      )}

      <Forms />
    </MediaWithFormsContainer>
  )
}

export default MediaWithForms
